import { isEmptyArray } from '../objects/isEmpty';

export function containsTrueOrFalse(values: Array<boolean | undefined>): boolean | undefined {
	// Array is empty
	if (isEmptyArray(values)) {
		return undefined;
	}

	// At least one value is true
	if (values.some((value) => value === true)) {
		return true;
	}

	// At least one value is false
	if (values.some((value) => value === false)) {
		return false;
	}

	return undefined;
}
